module.exports = __webpack_public_path__ + "static/img/empty.e3b4393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insure/empty.png
// module id = RlOh
// module chunks = 1